import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DxButtonModule, DxChartModule, DxPivotGridModule, DxTooltipModule } from 'devextreme-angular';
import { FieldsInterventionsTractorsSpeedWorkingAreaTimeReportComponent } from './fields-interventions-tractors-speed-working-area-time-report.component';


@NgModule({
  declarations: [FieldsInterventionsTractorsSpeedWorkingAreaTimeReportComponent],
  imports: [
    CommonModule,
    DxPivotGridModule,
    DxChartModule,
    DxButtonModule,
    DxTooltipModule,
  ],
  exports: [FieldsInterventionsTractorsSpeedWorkingAreaTimeReportComponent]
})
export class FieldsInterventionsTractorsSpeedWorkingAreaTimeReportModule { }
